
import { Card } from "@/components/ui/card";

interface AudienceCardProps {
  title: string;
  description: string;
  image: string;
  features: string[];
}

const AudienceCard = ({ title, description, image, features }: AudienceCardProps) => {
  return (
    <div className="bg-white rounded-xl shadow-md overflow-hidden h-full">
      <div className="h-48 overflow-hidden">
        <img 
          src={image} 
          alt={title}
          className="w-full h-full object-cover"
        />
      </div>
      <div className="p-6">
        <h3 className="text-xl font-bold text-abbella-ebony mb-2">{title}</h3>
        <p className="text-slate-600 mb-4">{description}</p>
        <ul className="space-y-2">
          {features.map((feature, idx) => (
            <li key={idx} className="flex items-start gap-2">
              <span className="text-abbella-aqua text-lg">•</span>
              <span className="text-sm text-slate-700">{feature}</span>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default AudienceCard;
